// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-smallOnWide-text-ddd8718a"};